
import React from 'react';
import { connect } from 'react-redux';
import { Tooltip } from 'reactstrap';
import Navbar from '../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../_components/common/SideNavBar'
import { orgAdminAreaData, AnalyzeData } from '../../../OrgAdminArea/SidebarData'
import { Link, NavLink } from 'react-router-dom'
import AnalysisNavBar from '../../../../../_components/common/AnalysisNavBar'
import DynamicGradientTables from '../../../../../_components/common/DynamicGradientTables'
import CircularButtonGroup from '../../../../../_components/common/CircularButtonGroup'
import ModularTooltip from '../../../../../_components/common/ModularTooltip'
import './index.css'
import { saveModulePermissionsAction, orgAdminAction, saveTeamDetailsAction, analyseActions } from '../../../../../_actions';
import { AnalyzeAction } from '../../../../../_actions/Analyze/analyze.action'
import dataFormater from '../../dataFormater'
import buttonDataFormater from '../../buttonDataFormater'
import {global_data} from '../../globalData'

import rightMark from '../../../../../images/right_mark.png'
import reviewQuestionsIcon from '../../../../../images/reviewQuestionsIcon.png'
import reviewQuestionsTitle from '../../../../../images/reviewQuestionsTitle.png'
import reviewQuestions1 from '../../../../../images/reviewQuestions1.png'
import reviewQuestions2 from '../../../../../images/reviewQuestions2.png'
import reviewQuestions3 from '../../../../../images/reviewQuestions3.png'
import reviewQuestions4 from '../../../../../images/reviewQuestions4.png'





const RoutableGradientTable = (props) => {
    return (
        <div className="d-flex flex-column">
            {
                props.data.map((val, key) => {
                    if (val.id == props.routerId) {
                        return (
                            <div key={key} className="font-reducal">
                                <div className={"d-flex flex-column w-100 py-3 my-1"} style={{ backgroundImage: `url(${reviewQuestionsTitle})` }}>
                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                        <NavLink to={val.navigation_arrow_link + `${props.routerId == 0 ? 0 : (parseInt(props.routerId, 10) - 1)}`} className="navigation-arrow-container" style={{ opacity: props.routerId == 0 ? 0.3 : 1, pointerEvents: props.routerId == 0 ? 'none' : 'auto' }}>
                                            <i className="fa fa-arrow-left text-white font-weight-bold mb-0"></i>
                                        </NavLink>
                                        <h3 className={`mb-0 text-white`}>
                                            {val.header_text}
                                        </h3>
                                        <NavLink to={val.navigation_arrow_link + `${props.routerId == (props.data.length - 1) ? (props.data.length - 1) : (parseInt(props.routerId, 10) + 1)}`} className="navigation-arrow-container" style={{ opacity: props.routerId == (props.data.length - 1) ? 0.3 : 1, pointerEvents: props.routerId == (props.data.length - 1) ? 'none' : 'auto' }}>
                                            <i className="fa fa-arrow-right text-white font-weight-bold mb-0"></i>
                                        </NavLink>
                                    </div>
                                    <div className="justify-content-center">
                                        <h5 className={`mb-0 text-white font-italic`}>({val.header_sub_text})</h5>
                                    </div>
                                </div>
                                {
                                    val.chilc_data.map((val1, key) => {
                                        return (
                                            <div key={key} className="d-flex flex-row col-12 p-0 ">
                                                <div className="col-4 py-3 px-4 text-left my-1" style={{ backgroundImage: 'linear-gradient(to right, #fcf279 , #d4ce5b)' }}>
                                                    <h4 className="mb-0 font-weight-bold">{val1.flex1.header}</h4>
                                                    <h5 className="mb-0 font-weight-bold">{val1.flex1.header_sub}</h5>
                                                    <div className="py-3">
                                                        {
                                                            val1.flex1.points.map((val2, key) => {
                                                                return (
                                                                    <h4 key={key} className="px-2 font-weight-bold">
                                                                        {val2.text}
                                                                    </h4>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                                <div className="d-flex flex-column col-8 p-0 mx-1">
                                                    {
                                                        val1.flex2.sub_flex.map((val3, key) => {
                                                            return (
                                                                <div key={key} className="px-5 py-4 m-1 flex_1 d-flex align-items-center" style={{ backgroundImage: `url(${val3.background_image})`, backgroundSize: '150% 150%', backgroundPosition: 'left' }}>
                                                                    <h4 className="mb-0 font-weight-bold text-left">{val3.text}</h4>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                })
            }
        </div>
    )
}

class ReviewQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.renderCustomComponent = this.renderCustomComponent.bind(this)
        this.callBack = this.callBack.bind(this)
        this.state = {
            teamName: '',
            teamId: '',
            filterData: null,
            getPaUserPermissionListResponse: '',
            modularToolTip: false,
            navData: [],
            class_name: {
                main_container: 'd-flex flex-row col-6 px-0',
                container: {
                    container: "d-flex flex-column w-100 p-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 20,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row align-items-center text-white ',
                    header_container_non_routable_title: '',
                    header_container_non_routable_optional: '',
                },
                child_container: {
                    child_container: "d-flex flex-column px-0 h-100",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex px-5 py-3 mb-1 text-dark flex_1',
                    child_content_container_header: 'font-weight-bold ',
                    child_content_container_desc: '',
                    child_content_container_footer: '',
                }
            },
            class_name1: {
                main_container: 'd-flex flex-row col-6 px-0',
                container: {
                    container: "d-flex flex-column w-100 p-1",
                    style: {
                        margin: 1
                    }
                },
                header_container: {
                    header_container: 'w-100 py-3 my-1',
                    style: {
                        paddingLeft: 20,
                        margin: 1
                    }
                },
                header_container_non_routable: {
                    header_container_non_routable: 'd-flex flex-row align-items-center text-white font-italic',
                    header_container_non_routable_title: '',
                    header_container_non_routable_optional: '',
                },
                child_container: {
                    child_container: "d-flex flex-column px-0",
                    style: {
                        margin: 1
                    }
                },
                child_content_container: {
                    child_content_container: 'd-flex px-2 mb-1 text-dark re-qu-padding',
                    child_content_container_header: 'p-3 fontReviewQTuts',
                    child_content_container_desc: 'font-weight-bold font-italic text-left re-qu-font',
                    child_content_container_footer: '',
                }
            },
            data1: [
                {
                    link: '',
                    header_background_image: reviewQuestionsTitle,
                    header_text: 'How to use these questions?',
                    header_sub_text: '',
                    child_content: [
                        {
                            child_content_background_color: `linear-gradient(90deg, #dcdc46, #fefa97)`,
                            child_header: "1",
                            child_content: "Don't confront your group with these questions but use them as triggers to drive your conversations toward addressing potential risks.",
                            child_footer: '',
                            link: '',
                        },
                        {
                            child_content_background_color: `linear-gradient(90deg, #fefa97, #dcdc46)`,
                            child_header: "2",
                            child_content: "Feel free to tweak these questions and/or use some of your own. Make sure to adopt a 'let-me-help-you' tone and body language.",
                            child_footer: '',
                            link: '',
                        },
                        {
                            child_content_background_color: `linear-gradient(90deg, #dddd46, #fefa97)`,
                            child_header: "3",
                            child_content: "Don't bring up all the questions for a given area at once, as not all of them are interconnected.",
                            child_footer: '',
                            link: '',
                        },
                        {
                            child_content_background_color: `linear-gradient(90deg, #fefa97, #dcdc46)`,
                            child_header: "4",
                            child_content: "The contexts recommended are suggestive, and it is up to you to pop these questions in appropriate settings.",
                            child_footer: '',
                            link: '',
                        }
                    ]
                }
            ],
            data: [],
            routable_table_data: [],

        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.saveAssesorGroupListResponse !== this.props.saveAssesorGroupListResponse) {
            if(this.props.saveAssesorGroupListResponse !== '') {
                this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
                })
            }
        }
        if(prevProp.AnalyzeDataResonse != this.props.AnalyzeDataResonse) {
            if(this.props.AnalyzeDataResonse !== '') {
                this.setState({
                    data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"review_questions"),
                    routable_table_data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"review_question_routable")
                })
            }
        }
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse !== '' ) {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Review Questions') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        //filter data

        if(this.props.saveAssesorGroupListResponse !== '') {
            this.setState({filterData: this.props.saveAssesorGroupListResponse},() => {
            })
        }

        //Analyze Data
        if(this.props.AnalyzeDataResonse !== '') {
            this.setState({
                    data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"review_questions"),
                    routable_table_data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"review_question_routable")
                })
        }
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    setData = (data) => {
        if(this.props.AnalyzeDataResonse.data != undefined) {
            this.setState({
                data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"review_questions"),
                routable_table_data: dataFormater(this.props,this.props.AnalyzeDataResonse.data,"review_question_routable")
            })
        }
    }

    callBack() {
        this.setState({ modularToolTip: false })
    }

    doSomthing = (data) => {
        this.setState({filterData : data}, () => {
            this.props.dispatch(analyseActions.saveAssessorGroups(this.state.filterData))            
        })
    }

    // onChangeTeam = (teamDetails) => {
    //     const team = {
    //         "team_id": teamDetails.analytics_team_id
    //     }
    //     this.props.dispatch(analyseActions.getAssessorGroupsHandler(team, () => {
    //         this.props.dispatch(analyseActions.saveAssessorGroups(this.props.assessorGroupsResponse))
    //     }))
    // }

    renderCustomComponent() {
        return (
            <div className="popover-body-div">
                <div style={{padding: '0 1.4rem'}}>
                    <div>
                        <p className="font-italic" style={{fontSize: 12, margin: 0}}>Ability to express opinions and ideas freely to the team members</p>
                    </div>
                    <div>
                        <p className="font-italic font-weight-bold" style={{fontSize: 10}}>(Relationship Orientation)</p>
                    </div>
                </div>
                <div className="popover-body-data ">
                    <img src={rightMark} style={{width: 26, height: 20}} />
                    <p className="font-weight-bold">Ensure you keep your learning ongoing and learn a new technique every week.</p>
                </div>
                <div className="popover-body-data">
                    <img src={rightMark} style={{width: 26, height: 20}} />
                    <p className="font-weight-bold">Take interest in understanding your team
                    mates better and their core motivations and
                    likes.</p>
                </div>
                <div className="popover-body-data">
                    <img src={rightMark} style={{width: 26, height: 20}} />
                    <p className="font-weight-bold">Keep yourself abreast with your field of work
                    and gain as much new knowledge as
                    possible.</p>
                </div>
                <div className="popover-body-data">
                    <img src={rightMark} style={{width: 26, height: 20}} />
                    <p className="font-weight-bold">Actively participate in team events and show
                    your support to relates causes.</p>
                </div>
            </div>
        )
    }

    render() {
        const { navData } = this.state;
        const { saveAssesorGroupListResponse } = this.props;

        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                < div className="container-post-nav">
                    <SideNavBar
                        analyzeFilterData={this.state.filterData}
                        isAnalyse = {true}
                        organisationName={localStorage.getItem('orgName')}
                        orgId={this.props.match.params.id}
                        teamId={localStorage.getItem('teamId')}
                        teamName={localStorage.getItem('teamName')}
                    // onChangeTeam={(data) => this.onChangeTeam(data)}
                    />
                    <div className="analyz-container">
                        <AnalysisNavBar analyticsData={this.props.saveModulePermissionsResponse} orgId={this.props.match.params.id} analyticsType={'people'} />
                        {
                            this.props.singleValidatorResponse ?
                            <p className="m-3 text-center">
                                 Team Members should be more than 2
                            </p>:
                            <React.Fragment>
                                {this.props.AnalyzeDataResonse == '' ?
                                    !this.props.getAnalyzeError ?
                                        this.props.teamAvailabilityBoolean ?
                                            <p className="text-center mt-4">
                                                <i className="fas fa-spinner fa-spin " ></i>
                                                &nbsp;loading
                                            </p>
                                        :
                                            <p className="text-center mt-4">
                                                &nbsp;{this.props.teamAvailabilityText}
                                            </p>
                                    :
                                    <p className="text-center my-5">{this.props.getAnalyzeError.message}</p>
                                    :
                                    <div className="swot-container-sub">
                                        {
                                            this.props.match.params.reviewid == undefined ?
                                                <div className="gradient-flex" style={{ paddingLeft: 35, paddingRight: 35, paddingTop: 75 }}>
                                                    <div className="px-2">
                                                        <h5 className="font-weight-bold font-italic text-center">Make your Status or Operations reviews more focused and effective by bringing up questions provided for each of these potential problem areas.</h5>
                                                    </div>
                                                    <div className="d-flex flex-row flex-wrap col-12" style={{ paddingLeft: 0, paddingRight: 0 }}>
                                                    {
                                                        this.state.data.length != 0 ?
                                                        <DynamicGradientTables classNameProps={this.state.class_name} data={this.state.data} /> :
                                                        null
                                                    }
                                                        <DynamicGradientTables classNameProps={this.state.class_name1} data={this.state.data1} />
                                                    </div>
                                                </div> :
                                                <div className="gradient-flex" style={{ paddingLeft: 35, paddingRight: 35, paddingTop: 45 }}>
                                                    {/* <DynamicGradientTables data={this.state.data1} /> */}
                                                    <RoutableGradientTable data={this.state.routable_table_data} routerId={this.props.match.params.reviewid} />
                                                    <div className="d-flex flex-row justify-content-between">
                                                        <CircularButtonGroup buttonGroupData={[
                                                            {
                                                                img: reviewQuestionsIcon,
                                                                link: `/organisation/${this.props.match.params.id}/user/review-questions`,
                                                                name: "Review Questions",
                                                                id: this.props.match.params.reviewid,
                                                            },
                                                        ]} swotCatagory={this.props.match.params.reviewid} singleButton={true} textAlign={'justify-content-start'} toolTip={true} />
                                                        
                                                        {/*<div className="p-2 my-2 ml-2 mr-0 coaching-tips" id="target1" onClick={() => this.setState({ modularToolTip: !this.state.modularToolTip })}>
                                                            <small className="mb-0 text-white">Coaching Tips</small>
                                                            {/* {
                                                                this.state.modularToolTip ?
                                                                    <ModularTooltip modalHeader={true} toggleValue={this.state.modularToolTip} id={"target1"} customComponent={this.renderCustomComponent()} callbackPopover={this.callBack} placement="bottom" title="Initiative: Coaching Tips" /> :
                                                                    null
                                                            } */}
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                }
                            </React.Fragment>
                        }
                        
                    </div>
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;

    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const { getPaUserPermissionListLoading } = state.getPaUserPermissionListReducer;
    const getPaUserPermissionListError = state.getPaUserPermissionListReducer.error;
    const getPaUserPermissionListResponse = (!getPaUserPermissionListLoading && !getPaUserPermissionListError) ? state.getPaUserPermissionListReducer.data.data.message : '';

    const { assessorGroupsLoading } = state.assessorGroupsReducer;
    const assessorGroupsError = state.assessorGroupsReducer.error;
    const assessorGroupsResponse = (!assessorGroupsLoading && !assessorGroupsError) ? state.assessorGroupsReducer.data.data : '';

    //Analyze
    const { getAnalyzeLoading } = state.getAnalyzeData
    const getAnalyzeError = state.getAnalyzeData.error
    const AnalyzeDataResonse = (!getAnalyzeLoading && !getAnalyzeError) ?  state.getAnalyzeData.data : '';

    //Header Permission
    const { headPerLoading } = state.headerPermissionReducer
    const headPerLoadingError = state.headerPermissionReducer.error
    const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    const saveAssesorGroupListResponse = state.saveAssesorGroupListReducer.data;
    const saveAssesorIdsResponse = state.saveAssesorIdsReducer.data;
    const singleValidatorResponse = state.singleValidatorReducer.data;

    const teamAvailabilityText = state.teamAvailabilityReducer.data;
    const teamAvailabilityBoolean = state.teamAvailabilityReducer.availibility;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        getPaUserPermissionListResponse,
        assessorGroupsResponse,
        saveAssesorGroupListResponse,
        saveAssesorIdsResponse,
        AnalyzeDataResonse,
        getAnalyzeLoading,
        getAnalyzeError,
        singleValidatorResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,

        teamAvailabilityText,
        teamAvailabilityBoolean,

    }
}

export default connect(mapStateToProps)(ReviewQuestions)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/ReviewQuestions/index.js